export default "<div *ngFor=\"let key of legendKeys\" [innerHtml]=\"returnOutPut(key)\">\n   \n</div>";